// extracted by mini-css-extract-plugin
export default {"container":"TableItem_container__9pwK5","tableTitles":"TableItem_tableTitles__uAByu","tableTitle1":"TableItem_tableTitle1__dfOOA","tableTitle2":"TableItem_tableTitle2__jY9wG"};